/* API request complete path */
export const API_URL = process.env.REACT_APP_API_URL;

/* Website Url */
export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL;

/* Key for API authentication */
export const API_HEADER_AUTH_KEY = process.env.REACT_APP_API_HEADER_AUTH_KEY;

/* Images path */
export const WEBSITE_JS_URL				= 	API_URL+"frontend/js/";
export const WEBSITE_PUBLIC_IMG_URL		= 	API_URL+"frontend/images/";
export const WEBSITE_SETTINGS_IMG_URL	= 	API_URL+"frontend/uploads/settings/";
export const WEBSITE_IMG_URL 			= 	WEBSITE_URL+"images/";

/* Languages configurations */
export const ENGLISH_LANGUAGE_MONGO_ID	= "5a3a13238481824b077b23ca";
export const ENGLISH_LANGUAGE_CODE		= "en";
export const ARABIC_LANGUAGE_CODE		= "ar";
export const RUSSIAN_LANGUAGE_CODE		= "ru";

/* Default language configurations */
export const DEFAULT_LANGUAGE_CODE		= ENGLISH_LANGUAGE_CODE;
export const DEFAULT_LANGUAGE_ID		= ENGLISH_LANGUAGE_CODE;

/* Default country code */
export const  DEFAULT_COUNTRY_CODE	=	"+971";

export const LANGUAGES = [
	{"id" : ENGLISH_LANGUAGE_MONGO_ID, "name" : "English"}
];

/* Supported languages list */
export const LANGUAGE_CODES = {};
LANGUAGE_CODES[ENGLISH_LANGUAGE_CODE]	=	ENGLISH_LANGUAGE_CODE;
LANGUAGE_CODES[ARABIC_LANGUAGE_CODE]	=	ARABIC_LANGUAGE_CODE;
LANGUAGE_CODES[RUSSIAN_LANGUAGE_CODE]	=	RUSSIAN_LANGUAGE_CODE;

/** Mongodb Sorting types */
export const SORT_ASC  = 1;
export const SORT_DESC = -1;

/** For currency symbol */
export const CURRENCY_SYMBOL = 'INR';
export const CURRENCY_CODE = '₹';

/* Supported languages list at product add and edit section */
export const LANGUAGE_SHORT_CODES_WITH_TITLE = [
	{"id" : ENGLISH_LANGUAGE_MONGO_ID, "name" : "English", "short_code"	: ENGLISH_LANGUAGE_CODE},
];

/** Date format **/
export const AM_PM_FORMAT_WITH_DATE					=	"YYYY/MM/DD hh:mm A";
export const ORDER_FORMAT_WITH_DATE					=	"DD MMMM YYYY";
export const BLOG_FORMAT_WITH_DATE					=	"DD MMMM, YYYY";
export const DATABASE_DATE_FORMAT 	    			= 	"YYYY-MM-DD";
export const PROPERTY_FORMAT_WITH_DATE				=	"DD MMMM";
export const BOOKING_FORMAT_WITH_DATE				=	"DD MMMM, YYYY hh:mm A";
export const BOOKING_CHECKIN_CHECKOUT				=	"DD/MM/YYYY";
export const BOOKING_CHECKIN_CHECKOUT_TIME			=	"hh:mm A";
export const DATERANGE_PICKER_FORMAT				=	"MM/dd/yyyy HH:mm";
export const CHECKIN_CHECKOUT_24_HOUR_FORMAT		=	"HH:mm";
export const DATERANGE_PICKER_FORMAT_WITHOUT_TIME	=	"MM/dd/yyyy";
export const DATE_RANGE_TIME_FORMAT					=	"DD/MM/YYYY HH:mm";

/** API status */
export const STATUS_SUCCESS = "success";
export const STATUS_ERROR 	= "error";

export const ROUND_PRECISION 	 	= 2;
export const HOME_CATEGORY_LIMIT 	= 3;
export const HOME_PROPERTY_LIMIT  	= 3;
export const PROPERTY_LISTING_LIMIT  = 12;
export const SEARCH_TERM_PROPERTY_LISTING_LIMIT  = 3;
export const BLOG_LISTING_LIMIT 	= 20;
export const LATEST_BLOG_LIMIT 		= 1;
export const FEATURED_BLOG_LIMIT 	= 3;
export const HEADER_PROPERTY_LIMIT  	= 6;
export const MIN_NUMBER_OF_GUEST  	= 0;
export const MAX_NUMBER_OF_GUEST  	= 10;

/** Sort type */
export const HIGH_TO_LOW = "high_to_low";
export const LOW_TO_HIGH = "low_to_high";
export const NEW_ARRIVAL = "new_arrival";
export const DISCOUNT 	= "discount";

export const SIZE_ATTRIBUTE 	= "size";
export const COLOR_ATTRIBUTE 	= "color";

export const SIMPLE_PROPERTY 	=	"simple";
export const CONFIGURABLE_TYPE	= 	"configurable";

export const ACTIVE		= 	1;
export const DEACTIVE	= 	0;

export const NOT_READ	= 	0;

export const FORGOT_PASSWORD = "forgot_password";
export const RESET_PASSWORD = "reset_password";

export const MAX_CART_COUNTER = 99;
export const MAX_WISH_LIST_COUNTER = 99;


export const NOTIFICATION_ORDER_OUT_OF_DELIVERY =	3;
export const NOTIFICATION_ORDER_DELIVERED 		=	4;
export const NOTIFICATION_ORDER_CANCELLED 		=	5;

/** Order Status */
export const PAYMENT_PENDING		=	"payment_pending";
export const PAYMENT_FAILED			=	"payment_failed";

/** Order filter type */
export const NOT_YET_SHIPPED		=	"not_yet_shipped";
export const CANCELLED				=	"cancelled";
export const RETURNED				=	"returned";

/*Payment Order Status*/
export const ORDER_ACTIVE		=	"ACTIVE";
export const ORDER_PAID 		=	"PAID"; 

/** Filter order time period */
export const LAST_30_DAYS		=	"30days";
export const LAST_3_MONTHS		=	"3months";
export const MAX_PERVIOUS_MONTHS=	3;

/**For quantity dropdown limit */
export const QUANTITY_MAX_LIMIT  = 10;
export const CATEGORY_DISPLAY_LIMIT  = 10;
export const LATEST_CAREER_LIMIT = 5;
export const OVERSIZED_TSHIRT 	=	"oversized";
export const PERSONAL_TOUCH_CHARACTER_LIMIT = 15;
export const CREATION_TYPE_CUSTOM = "custom";

export const CASH 	=	"cash";
export const ONLINE	=	"online";

export const PENDING =	0;
export const APPROVED =	1;

/** OTP Type */
export const MOBILE_OTP = 'mobile_otp';
export const EMAIL_OTP = 'email_otp';

export const OTP_TYPE_EMAIL = 'email';
export const OTP_TYPE_MOBILE = 'mobile';


export const DIGIT_REGEX = /^\d+$/;

export const VALID_EMAIL_REGEX  = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const VALID_MOBILE_REGEX = /^[0-9]{1,12}$/; 


/* Property rating array */
export const PROPERTY_RATING = [
	{value : '', label : 'Select Rating'},
	{value : 1, label : 1},
	{value : 2, label : 2},
	{value : 3, label : 3},
	{value : 4, label : 4},
	{value : 5, label : 5},
];

export const GOOGLE_MAP_KEY	=	"AIzaSyCOgS0IOMuAuNqAqvyLfgXP7tb8BgPrd1A";

export const PAYMENT_TYPE_SPRIPE	=	"stripe";
export const PAYMENT_TYPE_TRIPLEA	=	"triplea";
export const ADD_BOOKING		=	"booking";
export const MODIFY_BOOKING	=	"modify";
export const EXTEND_BOOKING	=	"extend";
export const LATE_CHECK_OUT_BOOKING	=	"late-checkout";
export const ADD_ON_BOOKING	=	"add-on";
export const DEFAULT_COUNTRY_CODE_PHONE	=	"ae";
export const BOOKING_STATUS_APPROVED =	"approved";
export const BOOKING_STATUS_PENDING	 =	"pending";
export const BOOKING_STATUS_REJECTED =	"rejected";

export const BOOKING_PAST_TYPE 		=	"past";
export const BOOKING_CANCELLED_TYPE =	"cancelled";
